import { render, staticRenderFns } from "./Anestesiologia.vue?vue&type=template&id=18b4610c&scoped=true&"
import script from "./Anestesiologia.vue?vue&type=script&lang=js&"
export * from "./Anestesiologia.vue?vue&type=script&lang=js&"
import style0 from "./Anestesiologia.vue?vue&type=style&index=0&id=18b4610c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b4610c",
  null
  
)

export default component.exports